module.exports = __webpack_public_path__ + "img/contractor.689d301c.jpg";